module.exports = __webpack_public_path__ + "images/avatars/female/18.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/18.svg
// module id = zpKr
// module chunks = 51